import axios, { AxiosInstance, AxiosPromise } from 'axios';
import config from '@/appConfig.json';
import { QuestionResponse } from '@/store/models';

export default class QuestionService {

	public static getInstance(): QuestionService {
		return new this();
	}
	private resourceUrl: string = '/questions/';

	private apiClient: AxiosInstance = axios.create({
		baseURL: config.apiUrl,
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json',
			'Authorization': 'Bearer ' + localStorage.accessToken
		}
	});

	public async getQuestions(surveyId: number): Promise<QuestionResponse[]> {
		 const response = await this.apiClient.get(
			this.resourceUrl,
			{
				params:
				{
					survey_id: surveyId
				}
			});
			return response.data;
	}

	public getQuestion(id: number): AxiosPromise {
		return this.apiClient.get(this.resourceUrl + id);
	}
}
